export class PageSizeMapDto {
  key: string;
  pageSize: number;

  constructor(key: string, pageSize: number) {
    this.key = key;
    this.pageSize = pageSize;
  }
}
